export default __webpack_public_path__ + "static/media/ic-x.c52c5e40.svg";